import * as React from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import config from '../../../../constants/config'
import { DisputeObj, DisputeT } from '../../../../types/Dispute'
import { JobT } from '../../../../types/Job'
import { copyObject } from '../../../../utils'
import { AxiosInstance } from '../../../../utils/RequestMethods'
import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading'

import DisputeCommunicationsTab from './DisputeCommunicationsTab'
import DisputeImagesTab from './DisputeImagesTab/DisputeImagesTab'
import GenerateDisputeRebuttalTab from './GenerateDisputeRebuttalTab'



interface IDisputeTab {
    job: JobT
}


const DisputeTab: React.FC<IDisputeTab> = (props: IDisputeTab): JSX.Element => {

    const [dispute, setDispute] = React.useState<DisputeT>(copyObject(DisputeObj))
    const [initDisputeLoading, setInitDisputeLoading] = React.useState<boolean>(false)

    const [activeTab, setActiveTab] = React.useState<string>('summary')


    React.useEffect(() => {
        // Get dispute from dispute endpoint
        const fetchDispute = async () => {
            if (!initDisputeLoading) {
                await AxiosInstance.get(`${config.url.disputes}/${props.job.fkDispute}`).then((res) => {
                    setInitDisputeLoading(true)
                    setDispute(res.data)
                }).catch((err) => {
                    console.log(err)
                })
            }
        }

        fetchDispute().catch(console.error)
    }, [dispute])


    const updateDispute = (key: string, value: any): void => {
        let disputeCopy: DisputeT = copyObject(dispute)
        disputeCopy[key] = value
        setDispute(disputeCopy)
    }


    return (
        <>
            <Button
                variant={activeTab == 'summary' ? 'light' : 'dark'}
                onClick={() => {
                    setActiveTab('summary')
                }}>Summary</Button>
            <Button
                variant={activeTab == 'communications' ? 'light' : 'dark'}
                onClick={() => {
                    setActiveTab('communications')
                }}>Communications</Button>
            <Button
                variant={activeTab == 'images' ? 'light' : 'dark'}
                onClick={() => {
                    setActiveTab('images')
                }}>Images</Button>
            <Button
                variant={activeTab == 'agreements' ? 'light' : 'dark'}
                onClick={() => {
                    setActiveTab('agreements')
                }}>Agreements</Button>
            <Button
                variant={activeTab == 'generate' ? 'light' : 'dark'}
                onClick={() => {
                    setActiveTab('generate')
                }}>Generate</Button>


            {activeTab == 'summary' && <Form style={{ padding: 20 }}>
                <Form.Group className="mb-3" control-id="disputeSummary">
                    <h1>Summary</h1>
                    <Form.Control
                        as="textarea"
                        rows={10}
                        onChange={(event: any) => {
                            updateDispute("summary", event.target.value)
                        }}
                        value={dispute.summary} />
                </Form.Group>
                <ButtonLoading
                    variant="success"
                    timeShowMsg={100}
                    onClickFetching={async (event): Promise<string> => {
                        let disputeCopy: DisputeT = copyObject(dispute)
                        disputeCopy['summary'] = dispute.summary
                        return await AxiosInstance.post(`${config.url.disputes}/${props.job.fkDispute}/save`,
                            {
                                "dispute": disputeCopy
                            }).then((res) => {
                                //alert(res.data)
                                return 'Dispute summary saved.'
                            })
                    }
                    }>Save</ButtonLoading>
            </Form>}


            {activeTab == 'communications' && <div>
                <DisputeCommunicationsTab job={props?.job} />
            </div>}


            {activeTab == 'images' && <div>  <DisputeImagesTab job={props?.job} dispute={dispute} onChangeDispute={(dispute) => setDispute(dispute)} /></div>}
            {activeTab == 'generate' && <div>  <GenerateDisputeRebuttalTab job={props?.job} /></div>}
        </>
    )
}


export default DisputeTab